// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"d4b6b85f","220":"364b71f2","314":"ae0b6279","779":"1782b0bc"}[chunkId] + ".chunk.js";
};